import React, { useState, useCallback, useMemo } from "react";
import { iDataTableProps } from './iTableProps';
import Operations from './../../../../common/CardAndDataTable/DataTableOperations';
import Table from './../../../../common/MergeTable';

const DataTable = function DataTable (props:iDataTableProps) {
  const { operationItems, operationTypeProps, operationType, columns } = props;
  const [foldStatus, setFoldStatus] = useState(false);

  function changeFoldStatus () {
    setFoldStatus(!foldStatus);
  }

  const getHoverContent = useCallback(function getHoverContent (record, index) {
    const { operationItems = [], operationTypeProps = {}, operationType, rowKey = "id", operationClick, fieldid } = props;
    // let newOperationItems = getOperationItems({operationItems,deleteInfo,onDelete:this.onDelete});
    let operationRender = null;
    const operationProps = {
      operationItems,
      operationClick,
      operationItemsMaxCount: operationTypeProps?.maxCount,
      operationType,
      record,
      index,
      rowKey,
      fieldid,
      foldStatus,
      setFoldStatus: changeFoldStatus
    }

    if (typeof operationType === 'function') {
      const res = operationType(operationItems, record, index);
      if (res instanceof Array) {
        operationRender = <Operations {...operationProps} operationItems={res}/>
      } else {
        operationRender = res
      }
    } else {
      if (!operationItems.length) {
        return null
      }
      operationRender = <Operations {...operationProps}/>
    }

    return operationRender
  }, [operationItems, operationTypeProps, operationType, foldStatus])

  const tableColmns = useMemo(() => {
    const operationColumn = [{
      title: "",
      dataIndex: "operation",
      fixed: "right",
      width: 72,
      className: "as-tableOperation",
      render: (text, record, index) => {
        return getHoverContent(record, index);
      }
    }]
    if (foldStatus) {
      return [...columns, ...operationColumn]
    } else {
      return [...columns]
    }
  }, [columns, foldStatus, operationType])

  const restProps = { ...props };
  delete restProps.children;
  return <Table {...restProps} columns={tableColmns} hoverContent={foldStatus ? null : getHoverContent}/>
}

export default DataTable;